export const en = {
    'all-conditions-are-negative': '"None fulfilled" cannot be set for all rule sets.',
    'app-metrika-segment': 'AppMetrica segment',
    composition: 'combined',
    'condition-rule-id-required': 'No goal specified',
    'condition-rule-period-required': 'Number of days not specified',
    'condition-rule-period-value-interval': 'Specify the correct number of days: from {minValue} to {maxValue}}',
    'condition-rule-period-value-max-value': 'The number of days must not exceed {value}',
    'condition-rule-period-value-negative-value': 'The number of days cannot be negative',
    crm: 'CRM data',
    'description-max-length': 'Note must not exceed {value} characters in length',
    'description-must-contain-only-symbols':
        'In the note, you can use Latin, Turkish, Russian, Ukrainian, and Kazakh letters, digits, and punctuation marks.',
    email: 'Email',
    'geo-condition': 'geo criteria',
    'geo-now': 'geo now',
    'geo-regular': 'geo regular',
    'goals-or-segment-error': 'Please select goals or segments in rule set {numberOfGroups}',
    'inconsistent-name': 'A retargeting list with this name already exists',
    'inconsistent-rules-groups': 'A retargeting list with these sets of rules already exists',
    'incorrect-goal-id': 'Invalid goal specified',
    'look-alike': 'similar segment',
    mac: 'MAC addresses',
    median: 'median',
    'metrika-segment': 'Yandex.Metrica segment',
    'mobiles-ids': 'Mobile ID',
    'name-max-length': 'The name of the retargeting list must not exceed {value} characters',
    'name-must-contain-only-symbols':
        'In the retargeting list name, you can use Latin, Turkish, Russian, Ukrainian, and Kazakh letters, digits, and punctuation marks.',
    'name-required': 'Retargeting list name not specified',
    phones: 'phones',
    pixel: 'pixel',
    'required-goal-id': 'No goal specified',
    'required-goal-period': 'You must specify a period for rules containing segments and Yandex.Metrica goals',
    'rules-groups-cannot-be-null': 'At least one set of rules must be set in the retargeting list',
    'unknown-error': 'Failed to save the retargeting list',
    'yandex-data': 'Yandex data'
};
